import { Injectable } from '@angular/core';
import { HttpService, HttpHeaders } from '@app/shared/services/http/http.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SpecialtiesService {
  private specialtiesCache: any = null;
  private specialtyCache = new Map<string, any>();

  constructor(
    private http: HttpService
  ) { }

  public async getSpecialties(): Promise<any> {
    if (this.specialtiesCache) {
      return this.specialtiesCache;
    }
    try {
      const headers: HttpHeaders = {
        'Content-Type': 'application/json',
      };
      const resp: any = await this.http.get(`${environment.FIREBASE_API}getSpecialties`, { headers: headers });
      if (resp && resp.specialties) {
        this.specialtiesCache = resp.specialties;
        return resp.specialties;
      } else {
        return [];
      }
    } catch (error) {
      return {};
    }
  }

  public async getSpecialty(id: string): Promise<any> {
    if (this.specialtyCache.has(id)) {
      return this.specialtyCache.get(id);
    }
    try {
      const headers: HttpHeaders = {
        'Content-Type': 'application/json',
      };
      const resp: any = await this.http
        .post(
          `${environment.FIREBASE_API}getSpecialty`,
          {
            id: id,
          },
          { headers: headers }
        );
      if (resp) {
        this.specialtyCache.set(id, resp);
      }
      return resp;
    } catch (error) {
      return {};
    }
  }
}
